import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

function FieldSkeleton() {
  return (
    <div className="tw:flex tw:flex-col tw:gap-y-1.5">
      <Skeleton height={16} width={100} />
      <Skeleton height={44} width="100%" />
    </div>
  );
}

export function ProviderProfileFormSkeleton({ title }: { title: string }) {
  return (
    <DashboardCard2 title={title}>
      <div className="tw:grid tw:gap-5 tw:leading-1 tw:md:grid-cols-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <FieldSkeleton key={i} />
        ))}
      </div>
    </DashboardCard2>
  );
}
